import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'rk-stream-delete-dialog',
  templateUrl: './stream-delete-dialog.component.html',
  standalone: false,
})
export class StreamDeleteDialogComponent {
  constructor(
    private readonly dialogRef: MatDialogRef<StreamDeleteDialogComponent>,
  ) {}

  onCancel(): void {
    this.dialogRef.close(false);
  }

  onConfirm(): void {
    this.dialogRef.close(true);
  }
}
